// Shared site assets and contact info — used by header, footer, and all pages
export const LOGO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/3m4xmkko_mother%20hippo%20PNG.png";
export const STOP_FGM = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/k1wg42ea_IMG-20260408-WA0020.jpg";

// Founder
export const IMG_UN_PORTRAIT = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/1z4ync9x_0f3ca02b-fc29-4fc3-8619-cace5face658.jpg";
export const IMG_UN_TEAM = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/rlih0aze_041d3478-7f36-4506-be7c-c0d948f92cb1.jpg";

// Togo community life
export const IMG_MOTHER_DAUGHTER = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/ngy4j6ja_mini_magick20260212-25417-43yymf-1.jpg";
export const IMG_NEXT_GEN = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/htf238pc_mini_magick20260212-26085-7abq7w-1-1.jpg";

// Workshops — April 1-4, 2026 — bundled locally (no longer hot-linked from WordPress)
const WP = "/images/wp";
export const IMG_WORKSHOP_HERO = `${WP}/PHOTO-2026-04-05-16-21-50.jpg`;
export const IMG_WORKSHOP_BAGS = `${WP}/PHOTO-2026-04-05-16-20-42-1.jpg`;
export const IMG_WORKSHOP_BANNER = `${WP}/PHOTO-2026-04-05-16-21-49-2.jpg`;
export const IMG_WORKSHOP_GROUP = `${WP}/PHOTO-2026-04-05-16-21-41-3.jpg`;
export const IMG_WORKSHOP_TALK = `${WP}/PHOTO-2026-04-05-16-21-37-1.jpg`;
export const IMG_WORKSHOP_VILLAGE = `${WP}/PHOTO-2026-04-05-16-21-43-1.jpg`;
export const IMG_COMMUNITY_AFTER = `${WP}/PHOTO-2026-04-05-16-21-50-3.jpg`;
export const IMG_COMMUNITY_BEFORE = `${WP}/PHOTO-2026-04-05-16-20-37-1.jpg`;

// Press (bundled locally)
export const IMG_PRESS = `${WP}/Untitled-design-8-3.png`;

// Selifa music video (bundled locally — re-encoded H.264 540p)
export const MUSIC_VIDEO = `${WP}/selifa-music-video.mp4`;

// Labor Day — community photos honoring women in Togo (May 2026)
export const IMG_LABOR_DAY_1 = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/ykxk24c1_IMG-20260505-WA0006.jpg";
export const IMG_LABOR_DAY_2 = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/5ck3txia_IMG-20260505-WA0014.jpg";
export const IMG_LABOR_DAY_3 = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/0889x4xh_IMG-20260505-WA0017.jpg";
export const IMG_LABOR_DAY_4 = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/noojgvlv_IMG-20260505-WA0018.jpg";
export const IMG_LABOR_DAY_5 = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/owheqt0t_IMG-20260505-WA0020.jpg";

// Press / As seen in — March 2026 features
export const PRESS_FR = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/59wmro63_Screenshot%202026-05-13%20at%201.37.29%E2%80%AFPM.png";
export const PRESS_EN = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/2niv4yzd_Screenshot%202026-05-13%20at%201.37.53%E2%80%AFPM.png";
export const PRESS_WOMEN_OF_SOLUTIONS = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/f76m346t_Screenshot%202026-05-13%20at%201.40.04%E2%80%AFPM.png";

// Business plan PDF (latest)
export const BUSINESS_PLAN_PDF = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/rovl8cgz_Mother-Hippo-Business-Plan-2025.docx-2-2.pdf";

// 2026 Budget (Excel) — bundled locally
export const BUDGET_2026_XLSX = "/docs/mother-hippo-budget-2026.xlsx";

// SHERIFA Film — production gallery (June 2026)
export const SHERIFA_SCREENING = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/5fod7eo9_FB_IMG_1780872223931.jpg";
export const SHERIFA_MOTHER_DAUGHTER = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/y5funcww_mini_magick20260212-25417-43yymf-1%20%281%29.jpg";
export const SHERIFA_CHILDREN = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/3x8xamrx_Screenshot_20260607_154254_Facebook.jpg";
export const SHERIFA_SAVE_LIVES = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/ksg97o7t_Screenshot_20260607_154310_Facebook.jpg";
export const SHERIFA_YOUTUBE_ID = "gMRCgN5Jnpo";

// SHERIFA Premiere Event — red-carpet arrivals & cast lineup
export const SHERIFA_PREMIERE_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/n0yjj6i3_FB_IMG_1780946061844.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/w3gdyh8v_FB_IMG_1780945462945.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/6f505iew_FB_IMG_1780945839340.jpg",
];

// TVT Lomé, Togo — Interview (broadcast featuring Akondo Adjei)
export const TVT_LOME_HERO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/nwcl9m7l_PHOTO-2025-05-09-11-25-17.jpg";
export const TVT_LOME_VIDEO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/anuwzgrs_VIDEO-2025-05-09-01-53-40.mp4";
export const TVT_LOME_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/uy074h69_PHOTO-2025-05-09-11-25-05.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/j40tt9ep_PHOTO-2025-05-09-11-25-04.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/2lkiu97g_PHOTO-2025-05-09-11-25-04%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/0ypvg5o9_PHOTO-2021-11-27-02-56-14.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/v9trosyr_PHOTO-2021-11-27-02-56-04.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/p7eymlwa_PHOTO-2021-11-27-02-55-40.jpg",
];

// Zero Tolerance Day Workshop — Tindjassi Sarakawa, Togo (Feb 6, 2026)
export const ZTD_HERO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/1eynk8b7_eb99a44b-4135-4463-b94e-ebcf85cd03f5.JPG";
export const ZTD_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/0mho8bmv_c48122d7-bd49-4c36-8f17-dab800ff54a1.JPG",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/9ilx7gwq_be8095a4-998b-469c-be2c-693d42cc5afc.JPG",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/ix6sk9e7_815859d3-77a5-4095-aa01-a9e359a3d84e.JPG",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/qnimvcco_IMG_5869.JPG",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/gbqnrh31_IMG_5867.JPG",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/hml8wma1_IMG_5866.JPG",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/37ef358w_IMG_5863.JPG",
];

// UN Talks on FGM — Mother Hippo's participation at the United Nations
export const UN_TALKS_HERO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/5uz0dqf1_IMG_4573-scaled.jpg";
export const UN_TALKS_VIDEO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/h3ftkoer_VID-20260607-WA0001%20%281%29.mp4";
export const UN_TALKS_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/sqy6x7rg_FB_IMG_1780950470828.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/upgmn0lh_041d3478-7f36-4506-be7c-c0d948f92cb1%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/7oicp7mr_0f3ca02b-fc29-4fc3-8619-cace5face658%20%281%29.jpg",
];

// Sélifa's earliest years — Grandmother Mariama (B&W family photographs)
export const SELIFA_GRANDMOTHER = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/vuh9ucmu_61311706-415d-4b89-9cd3-2c9ef5109842.JPG";
export const SELIFA_AS_CHILD = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/3i5qsjxu_c95c016f-7c7e-4a97-a443-c60d501822de.JPG";

// Shared site URL for share-the-pledge buttons
export const SHARE_URL = (typeof window !== "undefined" && window.location?.origin) || "https://www.motherhippo.org";

// Contact info — keep here so footer + new pages stay in sync
export const CONTACT = {
  address: "4132 Rainbow Blvd, Suite #217\nLas Vegas, Nevada 89103",
  email: "info@motherhippo.org",
  phone: "+1 (702) 782-2263",
  locations: "Las Vegas, Nevada · Sokodé, Togo",
};
